module.exports = "./dist/fabric_a.svg?e23962ea465f43ac4939d300a5de680b";


//////////////////
// WEBPACK FOOTER
// ./src/img/fabric_a.svg
// module id = 94
// module chunks = 0